export const EMPLOYEES_ANSWER = [
  {
    key: 'UpTo10',
    label: '0 - 9'
  },
  {
    key: 'Between10And50',
    label: '10 - 49'
  },
  {
    key: 'Between50And100',
    label: '50 - 99'
  },
  {
    key: 'Between100And500',
    label: '100 - 499'
  },
  {
    key: 'Over500',
    label: '500+'
  }
];
